module.exports = __webpack_public_path__ + "static/media/auth-img.d609c17d.svg";